// extracted by mini-css-extract-plugin
export default {"faqSection":"faqSection__OTBiY","container":"container__NWRiN","content":"content__ZjNkN","title":"title__YjAzN","question":"question__MTBmM","answer":"answer__ZWY1M"};